
export default {
  props: {
    termsList: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
    initIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      curIndex: 0,
    }
  },
  watch: {
    initIndex(val) {
      this.curIndex = val
    },
  },
  methods: {
    handleItemClick(item, index) {
      this.curIndex = index
      this.$emit('change', item)
    },
    handleTabChange(key) {
      this.$emit('change', this.termsList[key])
    },
  },
}
